export interface Association {
  associationId: string;
  category: string;
  name: string;
  description: string;
  phone: string;
  isWhatsApp: boolean;
  imageUrl: string;
}

export const CATEGORYS = [
  {
    key: "food",
    label: "Alimentação",
  },
  {
    key: "events",
    label: "Eventos",
  },
  {
    key: "promotions",
    label: "Promoções",
  },
  {
    key: "personal",
    label: "Personal",
  },
  {
    key: "nutritionism",
    label: "Nutricionismo",
  },
  {
    key: "cars",
    label: "Automóveis",
  },
  {
    key: "consortium",
    label: "Consórcios",
  },
  {
    key: "aesthetics",
    label: "Estética",
  },
  {
    key: "others",
    label: "Outros",
  },
];
